import { AppDispatch, RootState } from './store';
import { setAppError, setInitialized, setLoading } from './appSlice';
import { firmRefresh, userRefresh } from './components/shared/auth.functions';
import { setCurrentUser } from './components/shared/redux/userSlicer';
import { resetFirmList, setCurrentFirmList } from './components/shared/redux/firmListSlicer';
import { resetCurrentFirm, setCurrentFirm } from './components/shared/redux/firmSlicer';
import { resetCompanyList, setCurrentCompanyList } from './components/shared/redux/companySlicer';


export const initializeApp = () => async (dispatch: AppDispatch, getState: () => RootState) => {

  try {
    dispatch(setLoading(true));
    dispatch(setAppError(null));

    // Параллельно
    const [user, firms] = await Promise.all([
      userRefresh(dispatch),   // уже сетит currentUser внутри
      firmRefresh(),   // только возвращает массив
    ]);

    // Если userRefresh сам сетит компании пользователя — решите, что для вас “истина”.
    // Ниже версия, когда список компаний определяется выбранной фирмой.
    if (user) {
      dispatch(setCurrentUser(user));
    }

    const normalized = (firms ?? []).map((f: any) => ({
      ...f,
      _id: f?._id ?? f?.id ?? f?.uuid ?? f?.name, // унификация идентификатора
    }));

    if (!normalized.length) {
      // Нет фирм — всё сбрасываем
      dispatch(resetFirmList());
      dispatch(resetCurrentFirm());
      dispatch(resetCompanyList());
      dispatch(setCurrentFirmList([]));
      dispatch(setInitialized(true));
      return;
    }

    dispatch(setCurrentFirmList(normalized));

    // Сюда можно добавить восстановление “последней выбранной фирмы” из localStorage
    const currentFirm = getState().currentFirm.currentFirm;

    const nextFirm =
      (currentFirm && normalized.find((f: any) => f._id === currentFirm._id)) || normalized[0];


    dispatch(setCurrentFirm(nextFirm));
    dispatch(setCurrentCompanyList(nextFirm?.companies || []));

    dispatch(setInitialized(true));
  } catch (e: any) {
    dispatch(setAppError(e?.message ?? 'Initialization failed'));
    dispatch(setInitialized(false));
    // по желанию: тост об ошибке
  } finally {
    dispatch(setLoading(false));
  }
};
